import { CustomerFeeScheduleDTO } from "../DTO/customerFeeScheduleDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateCustomerFeeScheduleRequest extends BasicRequest{
    public customerFeeSchedule!:CustomerFeeScheduleDTO
}